import { useState } from 'react';
import useMaps from '../hooks/useMaps';
import tomodal from '../assets/tomodal.svg';
import { useAtom } from 'jotai';
import { isMobile, showMapsViewAtom } from '../states/planner';

export const MapButton = () => {
  const [, setShowMapsView] = useAtom(showMapsViewAtom);
  const [maps] = useMaps();
  const [clicked, setClicked] = useState(false);

  if (!maps || maps.length === 0) return null;

  const handleClick = () => {
    if (isMobile()) {
      setClicked(true);

      setTimeout(() => {
        setClicked(false);
        setShowMapsView(true);
      }, 450); // matches your delay
    } else {
      setShowMapsView(true);
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`relative bottom-0 left-2 flex w-auto items-center gap-1.5 whitespace-nowrap rounded-md bg-black bg-opacity-50 px-2 py-0.5 text-white opacity-90 sm:origin-center sm:transform sm:gap-2 sm:px-3 sm:py-1 sm:text-sm sm:transition sm:duration-100 sm:hover:scale-105 ${clicked ? 'scale-95 bg-[#00965f]/80' : ''}`}
    >
      Karta
      <img src={tomodal} alt="open modal" />
      {clicked && <span className="absolute inset-0 animate-ping rounded-md bg-white/30"></span>}
    </button>
  );
};
